module.exports = __webpack_public_path__ + "img/ipad-cn-11.bac0833.jpg";